import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';
import { validationText } from '@/util/master/masterErrors';
import { buildMasterParams } from '@/util/master/masterQuery';
import { pickExactMatch } from '@/util/master/searchOptions';

// Pakai axiosInstance global, jangan .create() kayak MasterApi: baseURL-nya bisa ketimpa undefined.
export function createMasterCrud(masterName) {
  const basePath = `/master/${masterName}`;

  return {
    async list(params) {
      const { data } = await axiosInstance.get(basePath, {
        params,
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async get(id) {
      const { data } = await axiosInstance.get(`${basePath}/${id}`, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async create(payload) {
      const { data } = await axiosInstance.post(basePath, payload, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async update(id, payload) {
      const { data } = await axiosInstance.put(`${basePath}/${id}`, payload, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
    async remove(id) {
      const { data } = await axiosInstance.delete(`${basePath}/${id}`, {
        cancelToken: getNewCancelToken(),
      });
      return data;
    },
  };
}

/**
 * Cari opsi dropdown ke backend lewat `finds[source.searchField]` (LIKE).
 * Tanpa `query`, balikin baris teratas (buat isi awal pas dropdown dibuka).
 * @param {{master:string, keyField:string, displayField:string, searchField:string}} source
 * @param {{query?: string, max?: number}} [opts]
 * @returns {Promise<Array<{value:*, text:string}>>}
 */
export async function searchSourceOptions(source, { query = '', max = 50 } = {}) {
  const {
    master, keyField, displayField, searchField,
  } = source;
  const finds = query ? { [searchField]: query } : {};
  const body = await createMasterCrud(master).list(buildMasterParams({ page: 1, max, finds }));
  const rows = Array.isArray(body.data) ? body.data : [];
  return rows.map((row) => ({ value: row[keyField], text: row[displayField] }));
}

/**
 * Ambil satu opsi source persis by id. `finds[source.keyField]` di backend
 * itu LIKE (bisa ikut nangkep id lain yang subset-nya cocok), jadi hasilnya
 * disaring ulang ke baris yang persis sama sebelum dipakai.
 * @param {{master:string, keyField:string, displayField:string}} source
 * @param {*} value
 * @returns {Promise<{value:*, text:string}|null>}
 */
export async function findSourceOption(source, value) {
  if (value === '' || value === null || value === undefined) return null;
  const { master, keyField, displayField } = source;
  const body = await createMasterCrud(master).list(
    buildMasterParams({ page: 1, max: 100, finds: { [keyField]: value } }),
  );
  const rows = Array.isArray(body.data) ? body.data : [];
  const hit = pickExactMatch(rows, keyField, value);
  return hit ? { value: hit[keyField], text: hit[displayField] } : null;
}

export function isOk(body) {
  return !!(body && body.status && body.status.error === 0);
}

export function bodyMessage(body) {
  return validationText(body && body.status ? body.status.message : '');
}
